import { Link, useMatch } from "@tanstack/react-router";
import { type PropsWithChildren } from "react";

type SettingsDestination = "appleHealth" | "strava" | "stravaActivities";

interface SettingsContextLinkProps extends PropsWithChildren {
  className?: string;
  destination: SettingsDestination;
}

const organizationPaths = {
  appleHealth: "/orgs/$slug/settings/integrations/apple-health",
  strava: "/orgs/$slug/settings/integrations/strava",
  stravaActivities: "/orgs/$slug/settings/integrations/strava/activities",
} as const;

const personalPaths = {
  appleHealth: "/settings/integrations/apple-health",
  strava: "/settings/integrations/strava",
  stravaActivities: "/settings/integrations/strava/activities",
} as const;

export function SettingsContextLink(props: SettingsContextLinkProps) {
  const organizationSlug = useMatch({
    from: "/_auth/_coach/orgs/$slug",
    shouldThrow: false,
    select: (match) => {
      return match.params.slug;
    },
  });

  if (organizationSlug) {
    return (
      <Link
        className={props.className}
        to={organizationPaths[props.destination]}
        params={{ slug: organizationSlug }}
      >
        {props.children}
      </Link>
    );
  }

  return (
    <Link className={props.className} to={personalPaths[props.destination]}>
      {props.children}
    </Link>
  );
}
